window.addEventListener('load', function () {
    if(document.querySelector('.subscription-radio')){
      document.querySelector('.subscription-radio').classList.contains('rc-radio--active') ? document.querySelector('.shopify-payment-button').classList.add('disabled') : null;
      document.querySelectorAll('.rc-radio').forEach(function (radio) {
          radio.addEventListener('click', function () {
              if (radio.classList.contains('subscription-radio')) {
                  document.querySelector('.shopify-payment-button').classList.add('disabled');
  
              } else {
                  document.querySelector('.shopify-payment-button').classList.remove('disabled');
              }
          });
      });
  
      setTimeout(function () {
          document.querySelector('.foxkit-product-bundles__discount path').setAttribute('fill', '#60269E');
      }, 1000);
    }
});